module.exports = __webpack_public_path__ + "static/media/Camera.78bd726a.svg";